import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import MuiPopper from '@material-ui/core/Popper';
import { styled, useRcPortalWindowContext, useThemeProps, } from '../../foundation';
import { PopperStyle } from './styles';
import { fixOffsetsModifer } from './modifiers';
var _RcPopper = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcPopper' });
    var children = props.children, modifiers = props.modifiers, rest = __rest(props, ["children", "modifiers"]);
    var externalWindow = useRcPortalWindowContext().externalWindow;
    return (React.createElement(MuiPopper, __assign({ container: externalWindow === null || externalWindow === void 0 ? void 0 : externalWindow.document.body }, rest, { modifiers: __assign({ fixOffsets: fixOffsetsModifer }, modifiers), ref: ref }), children));
});
var RcPopper = styled(_RcPopper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), PopperStyle);
RcPopper.defaultProps = {};
RcPopper.displayName = 'RcPopper';
export { RcPopper };
var templateObject_1;
